// The current application coordinates were pre-registered in a B2C tenant.
export let apiConfig = {
    b2cScopes: [
        'https://domeaiam.onmicrosoft.com/identity-api/api'
    ],
    //webApi: "https://fabrikamb2chello.azurewebsites.net/hello"
};